export default __webpack_public_path__ + "static/media/Bux_Card_Icon.258a7d8e.svg";